'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaUsb = function FaUsb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm40.1 18.4q0.2 0.1 0.2 0.5t-0.2 0.5l-5.6 3.3q-0.2 0.1-0.3 0.1-0.2 0-0.3-0.1-0.3-0.1-0.3-0.5v-2.2h-15q0.6 1 1.4 2.9 0.3 0.6 0.5 1t0.4 0.8 0.5 0.8 0.4 0.6 0.6 0.5 0.6 0.1h1.7v-1.7q0-0.2 0.1-0.4t0.4-0.1h5.6q0.3 0 0.4 0.1t0.2 0.4v5.6q0 0.3-0.2 0.4t-0.4 0.2h-5.6q-0.2 0-0.4-0.2t-0.1-0.4v-1.6h-1.7q-0.6 0-1.1-0.2t-0.9-0.4-0.8-0.7-0.6-0.8-0.6-1-0.5-1-0.5-1.1q-0.4-0.9-0.6-1.4t-0.7-1.2-0.8-0.9-0.8-0.3h-6.3q-0.4 1.5-1.6 2.4t-2.7 1q-1.9 0-3.2-1.3t-1.3-3.2 1.3-3.2 3.2-1.3q1.5 0 2.7 0.9t1.6 2.5h1.8q0.5 0 0.9-0.3t0.7-1 0.7-1.1 0.6-1.4q0.3-0.8 0.5-1.1t0.5-1 0.6-1 0.6-0.8 0.8-0.7 0.9-0.4 1.1-0.2h1.9q0.3-1 1.2-1.6t1.9-0.6q1.4 0 2.4 0.9t1 2.4-1 2.4-2.4 1q-1.1 0-1.9-0.6t-1.2-1.7h-1.9q-0.3 0-0.6 0.2t-0.5 0.4-0.5 0.6-0.5 0.9-0.4 0.8-0.4 1q-0.8 1.8-1.5 2.9h19.5v-2.3q0-0.3 0.3-0.5t0.6 0z' })
        )
    );
};

exports.default = FaUsb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/usb.js
// module id = 625
// module chunks = 58411574672382 79611799117203 84521481881339 164655002686464